import React from "react";
import Header from "../components/Header";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import { FiStar } from "react-icons/fi";
import { useSEO } from "../hooks/useSEO";

function Testimonials() {
  useSEO({
    title: "Client Testimonials | Success Stories | Empower Web",
    description:
      "Read testimonials from our satisfied clients. See the results and impact we've created through web development and digital marketing services.",
    canonical: "https://empowerweb.in/testimonials",
    ogTitle: "Client Testimonials | Success Stories & Reviews",
    ogDescription:
      "Discover what our clients say about working with us and the results we've achieved together.",
    keywords:
      "testimonials, client reviews, success stories, client feedback, results, case studies",
  });
  const testimonials = [
    {
      id: 1,
      name: "Adesh Sharma",
      position: "Owner & Founder",
      company: "247DigiGrow",
      testimonial:
        "The Amazon reviews management platform combined with digital marketing services has been transformative for our business. We went from struggling with low reviews to managing 500+ seller accounts with 95% response rates. Our sales have increased significantly and the automation saves us hours every week.",
      rating: 5,
      service: "E-Commerce Platform + Digital Marketing",
    },
    {
      id: 2,
      name: "Dinesh Thakur",
      position: "Owner & Founder",
      company: "Sankalp Ayurveda",
      testimonial:
        "The e-commerce platform for our Ayurvedic medicines has opened up national markets for us. The lead generation and automation features are incredible. We've gone from 2000 to 5000+ monthly visitors and our conversion rate of 35% is unheard of in our industry. Highly recommended!",
      rating: 5,
      service: "React.js Development + Automation + Lead Generation",
    },
    {
      id: 3,
      name: "Sandeep Singh",
      position: "Owner & Founder",
      company: "SpeedRoutes",
      testimonial:
        "The courier delivery platform has revolutionized our operations. Real-time tracking, automated notifications, and efficient route management have made us 3x more productive. Our customers love the transparency and we've reduced operational costs by 20%. The best investment we made.",
      rating: 5,
      service: "WordPress-Based Delivery Platform",
    },
    {
      id: 4,
      name: "Ritu",
      position: "Owner & Founder",
      company: "EduiTalent",
      testimonial:
        "Working with this team on our HR and IT consultancy platform has been excellent. They understood our need to showcase expertise in .NET, Java, Python, and AI. We've acquired 20+ enterprise clients in the first year and our consultancy values have increased significantly. Great work!",
      rating: 5,
      service: "WordPress Platform + Tech Consultancy",
    },
  ];

  const StarRating = ({ rating }) => (
    <div style={{ display: "flex", gap: "5px", marginBottom: "10px" }}>
      {[...Array(rating)].map((_, i) => (
        <FiStar key={i} style={{ color: "#ffb800", fill: "#ffb800" }} />
      ))}
    </div>
  );

  return (
    <div>
      <Header />
      <Navbar />

      {/* Hero Section */}
      <section
        style={{
          background: "linear-gradient(135deg, #0868a0 0%, #0d5a8f 100%)",
          padding: "80px 40px",
          color: "white",
        }}
      >
        <div
          style={{ maxWidth: "1200px", margin: "0 auto", textAlign: "center" }}
        >
          <h1
            style={{
              fontSize: "2.4rem",
                  fontFamily: "system-ui",

              marginBottom: "20px",
              fontWeight: "400",
            }}
          >
            Client Testimonials
          </h1>
          <p
            style={{
              fontSize: "1.2rem",
              textAlign: "center",
              lineHeight: "1.8",
                fontFamily: "system-ui",
              maxWidth: "500px",
              margin: "0 auto",
            }}
          >
           Hear from our satisfied clients who trust our expertise, value our results, and consistently achieve growth, success, and long-term business impact.
          </p>
        </div>
      </section>

      {/* Stats Section */}
      <section style={{ background: "#f5f5f5", padding: "60px 40px" }}>
        <div style={{ maxWidth: "1200px", margin: "0 auto" }}>
          <div
            style={{
              display: "grid",
              gridTemplateColumns: "repeat(auto-fit, minmax(250px, 1fr))",
              gap: "40px",
              textAlign: "center",
            }}
          >
            <div>
              <h3
                style={{
                  fontSize: "2.5rem",
                  color: "#0868a0",
                  marginBottom: "10px",
                }}
              >
                200+
              </h3>
              <p style={{ color: "#666", fontSize: "1.1rem" }}>
                Satisfied Clients
              </p>
            </div>
            <div>
              <h3
                style={{
                  fontSize: "2.5rem",
                  color: "#0868a0",
                  marginBottom: "10px",
                }}
              >
                4.9/5
              </h3>
              <p style={{ color: "#666", fontSize: "1.1rem" }}>
                Average Rating
              </p>
            </div>
            <div>
              <h3
                style={{
                  fontSize: "2.5rem",
                  color: "#0868a0",
                  marginBottom: "10px",
                }}
              >
                98%
              </h3>
              <p style={{ color: "#666", fontSize: "1.1rem" }}>
                Client Retention
              </p>
            </div>
            <div>
              <h3
                style={{
                  fontSize: "2.5rem",
                  color: "#0868a0",
                  marginBottom: "10px",
                }}
              >
                50+
              </h3>
              <p style={{ color: "#666", fontSize: "1.1rem" }}>
                Projects Completed
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Testimonials Section */}
      <section style={{ padding: "80px 40px", background: "#fff" }}>
        <div style={{ maxWidth: "1200px", margin: "0 auto" }}>
          <div style={{ textAlign: "center", marginBottom: "60px" }}>
            <h2
              style={{
                fontSize: "2.5rem",
                color: "#0868a0",
                marginBottom: "20px",
              }}
            >
              What Our Clients Say
            </h2>
            <p
              style={{
                fontSize: "1.1rem",
                color: "#666",
                maxWidth: "600px",
                margin: "0 auto",
              }}
            >
              Real feedback from real clients who have experienced
              transformative results with our services.
            </p>
          </div>

          <div
            style={{
              display: "grid",
              gridTemplateColumns: "repeat(auto-fit, minmax(350px, 1fr))",
              gap: "30px",
            }}
          >
            {testimonials.map((testimonial) => (
              <div
                key={testimonial.id}
                style={{
                  background: "#f9f9f9",
                  padding: "30px",
                  borderRadius: "12px",
                  border: "1px solid #e0e0e0",
                  transition: "all 0.3s ease",
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.boxShadow =
                    "0 10px 30px rgba(8, 104, 160, 0.15)";
                  e.currentTarget.style.transform = "translateY(-5px)";
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.boxShadow = "none";
                  e.currentTarget.style.transform = "translateY(0)";
                }}
              >
                {/* Star Rating */}
                <StarRating rating={testimonial.rating} />

                {/* Testimonial Text */}
                <p
                  style={{
                    color: "#666",
                    fontStyle: "italic",
                    lineHeight: "1.7",
                    marginBottom: "20px",
                    fontSize: "0.95rem",
                  }}
                >
                  "{testimonial.testimonial}"
                </p>

                {/* Author Info */}
                <div
                  style={{ borderTop: "1px solid #e0e0e0", paddingTop: "15px" }}
                >
                  <p
                    style={{
                      color: "#0868a0",
                      fontWeight: "bold",
                      marginBottom: "5px",
                      margin: "0 0 5px 0",
                    }}
                  >
                    {testimonial.name}
                  </p>
                  <p
                    style={{
                      color: "#666",
                      fontSize: "0.85rem",
                      marginBottom: "8px",
                      margin: "0 0 8px 0",
                    }}
                  >
                    {testimonial.position} at{" "}
                    <strong>{testimonial.company}</strong>
                  </p>
                  <span
                    style={{
                      background: "#e3f2fd",
                      color: "#0868a0",
                      padding: "4px 10px",
                      borderRadius: "4px",
                      fontSize: "0.8rem",
                      display: "inline-block",
                    }}
                  >
                    {testimonial.service}
                  </span>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Video/Featured Testimonial Section */}
      <section style={{ background: "#f5f5f5", padding: "60px 40px" }}>
        <div style={{ maxWidth: "1200px", margin: "0 auto" }}>
          <h2
            style={{
              fontSize: "2.2rem",
              color: "#0868a0",
              marginBottom: "40px",
              fontWeight: "500",
              fontFamily: "system-ui",
              textAlign: "center",
            }}
          >
            Why Clients Trust Us
          </h2>

          <div
            style={{
              display: "grid",
              gridTemplateColumns: "repeat(auto-fit, minmax(280px, 1fr))",
              gap: "30px",
            }}
          >
            <div
              style={{
                background: "white",
                padding: "30px",
                borderRadius: "8px",
                textAlign: "center",
              }}
            >
              <div style={{ fontSize: "2.5rem", marginBottom: "15px" }}></div>
              <h3 style={{ color: "#0868a0", fontSize: "1.3rem",   fontWeight: "500",
              fontFamily: "system-ui",  marginBottom: "10px" }}>
                Proven Track Record
              </h3>
              <p style={{ color: "#666" ,fontWeight: "500",
              fontFamily: "system-ui", }}>
                50+ successful projects with measurable results and ROI for our
                clients.
              </p>
            </div>

            <div
              style={{
                background: "white",
                padding: "30px",
                borderRadius: "8px",
                textAlign: "center",
              }}
            >
              <div style={{ fontSize: "2.5rem", marginBottom: "15px" }}></div>
              <h3 style={{ color: "#0868a0", fontSize: "1.3rem",  fontWeight: "500",
              fontFamily: "system-ui", marginBottom: "10px" }}>
                Expert Team
              </h3>
              <p style={{ color: "#666" ,fontWeight: "500",
              fontFamily: "system-ui",}}>
                15+ experienced professionals with expertise in multiple
                technologies and industries.
              </p>
            </div>

            <div
              style={{
                background: "white",
                padding: "30px",
                borderRadius: "8px",
                textAlign: "center",
              }}
            >
              <div style={{ fontSize: "2.5rem", marginBottom: "15px" }}></div>
              <h3 style={{ color: "#0868a0", fontSize: "1.3rem",  fontWeight: "500",
              fontFamily: "system-ui", marginBottom: "10px" }}>
                Client-Focused
              </h3>
              <p style={{ color: "#666" ,fontWeight: "500",
              fontFamily: "system-ui",}}>
                We treat every client's success as our own. 98% client retention
                rate.
              </p>
            </div>

            <div
              style={{
                background: "white",
                padding: "30px",
                borderRadius: "8px",
                textAlign: "center",
              }}
            >
              <div style={{ fontSize: "2.5rem", marginBottom: "15px" }}></div>
              <h3 style={{ color: "#0868a0", fontSize: "1.3rem",  fontWeight: "500",
              fontFamily: "system-ui", marginBottom: "10px" }}>
                Data-Driven
              </h3>
              <p style={{ color: "#666",fontWeight: "500",
              fontFamily: "system-ui", }}>
                We focus on metrics that matter - ROI, growth, and customer
                satisfaction.
              </p>
            </div>

            <div
              style={{
                background: "white",
                padding: "30px",
                borderRadius: "8px",
                textAlign: "center",
              }}
            >
              <div style={{ fontSize: "2.5rem", marginBottom: "15px" }}></div>
              <h3 style={{ color: "#0868a0", fontSize: "1.3rem",  fontWeight: "500",
              fontFamily: "system-ui", marginBottom: "10px" }}>
                On-Time Delivery
              </h3>
              <p style={{ color: "#666", fontWeight: "500",
              fontFamily: "system-ui", }}>
                We respect deadlines and deliver quality work within the agreed
                timeline.
              </p>
            </div>

            <div
              style={{
                background: "white",
                padding: "30px",
                borderRadius: "8px",
                textAlign: "center",
              }}
            >
              <div style={{ fontSize: "2.5rem", marginBottom: "15px" }}></div>
              <h3 style={{ color: "#0868a0",fontSize: "1.3rem",   fontWeight: "500",
              fontFamily: "system-ui", marginBottom: "10px" }}>
                Ongoing Support
              </h3>
              <p style={{ color: "#666" ,fontWeight: "500",
              fontFamily: "system-ui",}}>
                Post-launch support and continuous optimization for long-term
                success.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section
        style={{
          background: "linear-gradient(135deg, #0868a0 0%, #0d5a8f 100%)",
          padding: "60px 40px",
          color: "white",
        }}
      >
        <div
          style={{ maxWidth: "1200px", margin: "0 auto", textAlign: "center" }}
        >
          <h2 style={{ fontSize: "2.2rem", marginBottom: "20px" }}>
            Ready to Become Our Next Success Story?
          </h2>
          <p style={{ fontSize: "1.1rem", marginBottom: "30px" }}>
            Let's discuss how we can help transform your business and achieve
            your goals.
          </p>
          <a
            href="/contact"
            style={{
              background: "white",
              color: "#0868a0",
              padding: "14px 32px",
              borderRadius: "6px",
              textDecoration: "none",
              fontWeight: "bold",
              display: "inline-block",
              transition: "all 0.3s ease",
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.transform = "scale(1.05)";
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.transform = "scale(1)";
            }}
          >
            Schedule a Consultation →
          </a>
        </div>
      </section>

      <Footer />
      
    </div>
  );
}

export default Testimonials;
